/**
 * @type {import("./types").CountryId[]}
 */
const countries = ["kz", "kg", "hu", "ro", "ae"];

export const availableCountries = {
  codes: countries,
  set: new Set(countries),
  /**
   * @param {any} code
   * @returns {import("./types").CountryId}
   */
  parse(code) {
    if (code && this.set.has(code)) {
      return code;
    }
    throw new Error(`Invalid country code: ${code}`);
  },
  /**
   * @param {any} code
   * @returns {{data?: import("./types").CountryId}}
   */
  safeParse(code) {
    if (code && this.set.has(code)) {
      return { data: code };
    }
    return { data: undefined };
  },
};

/**
 * @type {import("./types").LocaleId[]}
 */
const locales = ["ru", "en", "kk", "hu", "ro"];

export const availableLocales = {
  codes: locales,
  set: new Set(locales),
  /**
   * @param {any} code
   * @returns {import("./types").LocaleId}
   */
  parse(code) {
    if (code && this.set.has(code)) {
      return code;
    }
    throw new Error(`Invalid locale code: ${code}`);
  },
  /**
   * @param {any} code
   * @returns {{data?: import("./types").LocaleId}}
   */
  safeParse(code) {
    if (code && this.set.has(code)) {
      return { data: code };
    }
    return { data: undefined };
  },
};

/**
 * @param {import("./types").CountryId} countryId
 * @returns {import("./types").BaseCountryInfo}
 */
export const resolveCountryInfo = (countryId) => {
  switch (countryId) {
    case "kz":
      return {
        countryId: "kz",
        currency: "KZT",
        defaultLocale: "ru",
        ogLocale: "ru_KZ",
        locales: ["ru", "kk"],
        regionalLocales: {
          ru: "ru-kz",
          kk: "kk-kz",
        },
        brandName: "DOQ.kz",
        link: "https://doq.kz",
        phone: {
          code: "+7",
          city_code_length: 3,
          mask: "+7 (###) ###-##-##",
        },
        timeZone: "Asia/Almaty",
        doctorLocales: [],
        address: "Astana-Hub, Astana, Kazakhstan",
      };
    case "kg":
      return {
        countryId: "kg",
        currency: "KGS",
        defaultLocale: "ru",
        ogLocale: "ru_KG",
        locales: ["ru"],
        regionalLocales: {
          ru: "ru-kg",
        },
        brandName: "odoctor.kg",
        link: "https://odoctor.kg",
        phone: {
          code: "+996",
          city_code_length: 4,
          mask: "+996 (###) ##-##-##",
        },
        timeZone: "Asia/Bishkek",
        doctorLocales: [],
        address: "Astana-Hub, Astana, Kazakhstan",
      };
    case "hu":
      return {
        countryId: "hu",
        currency: "HUF",
        defaultLocale: "hu",
        ogLocale: "hu_HU",
        locales: ["hu", "en"],
        regionalLocales: {
          hu: "hu-hu",
          en: "en-hu",
        },
        brandName: "odoktor.hu",
        link: "https://odoktor.hu",
        phone: {
          code: "+36",
          city_code_length: 2,
          mask: "+36 (##) ###-####",
        },
        timeZone: "Europe/Budapest",
        doctorLocales: [
          { title: "Chinese", value: "zh-CN" },
          { title: "English", value: "en" },
          { title: "Hungarian", value: "hu" },
          { title: "German", value: "de" },
          { title: "Russian", value: "ru" },
          { title: "French", value: "fr" },
          { title: "Spanish", value: "es" },
          { title: "Romanian", value: "ro" },
          { title: "Arabic", value: "ar" },
          { title: "Turkish", value: "tr" },
          { title: "Italian", value: "it" },
        ],
        address: "1077 Budapest, Rózsa utca 38. A. ép.",
      };
    case "ro":
      return {
        countryId: "ro",
        currency: "RON",
        defaultLocale: "ro",
        ogLocale: "ro_RO",
        locales: ["ro", "en"],
        regionalLocales: {
          ro: "ro-ro",
          en: "en-ro",
        },
        brandName: "prodoctor.ro",
        link: "https://prodoctor.ro",
        phone: {
          code: "+40",
          city_code_length: 3,
          mask: "+40 (###) ### ###",
        },
        timeZone: "Europe/Bucharest",
        doctorLocales: [
          { title: "Romanian", value: "ro" },
          { title: "English", value: "en" },
          { title: "Hungarian", value: "hu" },
          { title: "French", value: "fr" },
          { title: "Russian", value: "ru" },
          { title: "Spanish", value: "es" },
          { title: "German", value: "de" },
          { title: "Arabic", value: "ar" },
        ],
        address:
          "Bucharest, 61 Unirii Boulevard, Block F3, Entrance 4, 2nd Floor, Apartment 208, District 3",
      };
    case "ae":
      return {
        countryId: "ae",
        currency: "AED",
        defaultLocale: "en",
        ogLocale: "ar_AE",
        locales: ["en", "ru"],
        regionalLocales: {
          hu: "en-ae",
          en: "ru-ae",
        },
        brandName: "odoctor.ae",
        link: "https://odoctor.ae",
        phone: {
          code: "+971",
          city_code_length: 4,
          mask: "+971 (##) ###-####",
        },
        timeZone: "Asia/Dubai",
        doctorLocales: [
          { title: "Arabic", value: "ar" },
          { title: "English", value: "en" },
          { title: "Russian", value: "ru" },
        ],
        address:
          "Business Centre, Sharjah Publishing City Free Zone, Sharjah, United Arab Emirates",
      };
  }
};
